import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/admin',
        pathMatch: 'full',
    },
    {
        path: 'chatbot',
        loadComponent: () => import('./features/chat/views/chatbot/chatbot.component').then((m) => m.ChatbotComponent),
    },
    {
        path: 'admin',
        redirectTo: '/admin/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'admin/configuration',
        loadComponent: () => import('./features/admin/views/config/config.component').then((m) => m.ConfigComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'admin/dashboard',
        loadComponent: () => import('./features/admin/views/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'admin/history',
        loadComponent: () => import('./features/admin/views/history/history.component').then((m) => m.HistoryComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'admin/report',
        loadComponent: () => import('./features/admin/views/report/report.component').then((m) => m.ReportComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'admin/settings',
        loadComponent: () => import('./features/admin/views/settings/settings.component').then((m) => m.SettingsComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'login',
        loadComponent: () => import('./features/auth/views/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'change-password',
        loadComponent: () =>
            import('./features/auth/views/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
    },
    {
        path: '**',
        redirectTo: '/chatbot',
    },
];
